import styled from "styled-components";

export const ContainerButton = styled.div`
  padding: 8px 8px 0;

  @media (min-width: 500px) {
    padding: 16px 24px;
  }
`;
